<template>
  <div class="about-container">
    <div class="banner-image">
      <img :src="'https://www.gzicv.org.cn/file/upload/media/banner/zMgjqweA_20200709094132_735.png'" alt="机构图片">
    </div>

    <div class="content-wrapper">
      <!-- 左侧步骤分类 -->
      <div class="left-sidebar">
        <div class="steps-wrapper">
          <div 
            v-for="step in steps" 
            :key="step.id"
            class="step-item"
            :class="{ active: activeStep === step.id }"
            @click="scrollToSection(step.id)"
          >
            <div class="step-title">{{ step.title }}</div>
          </div>
        </div>
      </div>
      
      <!-- 右侧内容区域 -->
      <div class="right-content" ref="contentRef">
      <!-- 简介部分 -->
      <div id="intro" class="content-section">
        <h2 class="section-title">机构简介</h2>
        <div class="section-content">
          <img src="http://xgame-icv.zbmec.com:9000/qf-test-management-provincial/about/about_bg.png" alt="机构简介背景图" class="section-image" />
          <p>甘肃省智慧交通与智能网联汽车综合测试应用示范基地建设在兰州新区，由甘肃省交通运输厅统筹规划，甘肃省公路交通建设集团负责实施，甘肃路桥飞宇交通设施有限责任公司投资建设，甘肃省智慧公路交通重点实验室技术支撑，甘肃新陆港科技有限公司运营管理，主要承担“第三方机构辅助支撑、智慧交通技术测试评估、智慧交通基础理论研究、智慧交通关键产品研发”等关键任务、打造省级车路协同自动驾驶产业创新平台。</p>
          <p>甘肃省智慧交通与智能网联汽车综合测试应用示范基地搭建了56.5公里车路协同自
            动驾驶测试应用场景，包括兰州新区城市开放道路测试区和兰州新区职教园区“自动驾驶客运、货运和园区”三大示范应用场景。</p>
          <p>未来，我们将继续秉承"客户至上、质量第一"的服务理念，不断创新和发展，为客户提供更加优质、高效的测试服务，为推动测试行业的发展做出更大的贡献。</p>
        </div>
      </div>
      
      <!-- 组织部分 -->
      <div id="organization" class="content-section">
        <h2 class="section-title">组织架构</h2>
        <div class="section-content">
          <div class="organization-group">
            <div class="group-title">主管单位</div>
            <div class="group-content">
              <div class="unit-list">
                <div class="unit-item">甘肃省交通运输厅</div>
              </div>
              <div class="unit-list">
                <div class="unit-item">兰州市交通运输局</div>
                <div class="unit-item">兰州市公安局</div>
              </div>
            </div>
          </div>

          <div class="organization-group">
            <div class="group-title">发起单位</div>
            <div class="group-content">
              <div class="unit-list">
                <div class="unit-item">甘肃省公路交通建设集团</div>
                <div class="unit-item">甘肃省智慧公路交通重点实验室</div>
              </div>
              <div class="unit-list">
                <div class="unit-item">甘肃路桥飞宇交通设施有限责任公司</div>
                <div class="unit-item">甘肃新陆港科技有限公司</div>
              </div>
            </div>
          </div>

<!--          <div class="organization-group">-->
<!--            <div class="group-title">理事会</div>-->
<!--            <div class="group-content board-content">-->
<!--              <div class="board-item">-->
<!--                <div class="board-label">理事长</div>-->
<!--                <div class="board-names">东皇太一</div>-->
<!--              </div>-->
<!--              <div class="board-item">-->
<!--                <div class="board-label">副理事长</div>-->
<!--                <div class="board-names">焱妃</div>-->
<!--              </div>-->
<!--              <div class="board-item">-->
<!--                <div class="board-label">理事</div>-->
<!--                <div class="board-names"> 姬如千泷 月神 星魂 云中君 楚南公</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="organization-group">-->
<!--            <div class="group-title">监事</div>-->
<!--            <div class="group-content board-content">-->
<!--              <div class="board-item">-->
<!--                <div class="board-names">大司命 少司命</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="organization-group">-->
<!--            <div class="group-title">部门</div>-->
<!--            <div class="group-content">-->
<!--              <div class="unit-list">-->
<!--                <div class="unit-item">战略发展部</div>-->
<!--                <div class="unit-item">项目推进部</div>-->
<!--              </div>-->
<!--              <div class="unit-list">-->
<!--                <div class="unit-item">技术服务部</div>-->
<!--                <div class="unit-item">外联合作不</div>-->
<!--              </div>-->
<!--              <div class="unit-list">-->
<!--                <div class="unit-item">综合管理部</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
      
      <!-- 主要资质部分 -->
      <div id="qualifications" class="content-section">
        <h2 class="section-title">主要资质</h2>
        <div class="section-content">
          <div class="qualifications-grid">
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/clxt.jpg" alt="质量管理体系认证" class="qualification-image" />
            </div>
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/znwlcp.jpg" alt="" class="qualification-image" />
            </div>
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/sfjg.jpg" alt="" class="qualification-image" />
            </div>
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/cwlsh.png" alt="" class="qualification-image" />
            </div>
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/v2x.jpg" alt="" class="qualification-image" />
            </div>
            <div class="qualification-item">
              <img src="https://testing-management-public.obs.cn-southwest-2.myhuaweicloud.com/testing-management-public/about/gsjtysxhls.png" alt="" class="qualification-image" />
            </div>
          </div>
          <p>我们始终注重资质建设和能力提升，通过不断的学习和实践，积累了丰富的经验和专业知识，能够为客户提供更加专业、可靠的测试服务。</p>
        </div>
      </div>
      
      <!-- 联系我们部分 -->
      <div id="contact" class="content-section">
        <h2 class="section-title">联系我们</h2>
        <div class="section-content contact-layout">
          <div class="contact-info">
            <div class="contact-item">
              <div class="contact-label">地址：</div>
              <div class="contact-value">甘肃省兰州新区松花江街1900号甘肃省智慧交通与智能网联汽车综合测试应用示范基地</div>
            </div>
            <div class="contact-item">
              <div class="contact-label">电话：</div>
              <div class="contact-value">010-12345678</div>
            </div>
            <div class="contact-item">
              <div class="contact-label">邮箱：</div>
              <div class="contact-value">info@example.com</div>
            </div>
            <div class="contact-item">
              <div class="contact-label">网址：</div>
              <div class="contact-value">www.example.com</div>
            </div>
            <div class="contact-item">
              <div class="contact-label">微信公众号：</div>
              <img class="contact-value" :src="require('@/assets/images/about_wx.png')" alt="微信公众号">
            </div>
          </div>

          <div class="map-container">
            <div id="company-map-container"></div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import Footer from '@/components/GlobalFooter/footer.vue'

// 公司地址经纬度
const companyLocation = { lon: 103.685398, lat: 36.623102 }

// 步骤列表
const steps = [
  { id: 'intro', title: '机构简介' },
  { id: 'organization', title: '组织架构' },
  { id: 'qualifications', title: '主要资质' },
  { id: 'contact', title: '联系我们' }
]

// 当前激活的步骤
const activeStep = ref('intro')

// 地图实例引用
const map = ref(null)

// 初始化地图并添加标记点
const initMap = async () => {
  try {
    await import('@amap/amap-jsapi-loader').then(AMapLoader => {
      return AMapLoader.default.load({
        key: '6588d9e5b6ae0751c799cb4c7b3e30be', // 使用项目中已有的高德地图API Key
        version: '2.0',
        plugins: ['AMap.Marker']
      })
    }).then(AMap => {
      // 创建地图实例
      map.value = new AMap.Map('company-map-container', {
        zoom: 11,
        mapStyle: 'amap://styles/45311ae996a8bea0da10ad5151f72979',
        center: [companyLocation.lon, companyLocation.lat]
      })
      const marker = new AMap.Marker({
        position: [companyLocation.lon, companyLocation.lat],
        title: '甘肃省智慧交通与智能网联汽车综合测试应用示范基地',
        icon: '//webapi.amap.com/theme/v1.3/markers/n/mark_r.png'
      })

      // 将标记点添加到地图上
      map.value.add(marker)
    })
  } catch (error) {
    console.error('地图初始化失败:', error)
  }
}

onMounted(() => {
  initMap()
})

onUnmounted(() => {
  if (map.value) {
    map.value.destroy()
  }
})

const contentRef = ref(null)

const sections = ref({})

const scrollToSection = (id) => {
  activeStep.value = id
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start' // 滚动到元素顶部
    })
  }
}

const handleScroll = () => {
  if (!contentRef.value) return

  const scrollTop = contentRef.value.scrollTop
  const windowHeight = contentRef.value.clientHeight

  let currentSection = activeStep.value
  let maxVisibleHeight = 0

  Object.keys(sections.value).forEach(id => {
    const section = sections.value[id]
    const sectionTop = section.top
    const sectionHeight = section.height

    const visibleTop = Math.max(0, sectionTop - scrollTop)
    const visibleBottom = Math.max(0, Math.min(sectionHeight, windowHeight - visibleTop))
    const visibleHeight = visibleBottom - visibleTop

    if (visibleHeight > maxVisibleHeight) {
      maxVisibleHeight = visibleHeight
      currentSection = id
    }
  })

  if (currentSection !== activeStep.value) {
    activeStep.value = currentSection
  }
}

const updateSectionsPosition = () => {
  sections.value = {}
  steps.forEach(step => {
    const element = document.getElementById(step.id)
    if (element) {
      sections.value[step.id] = {
        top: element.offsetTop,
        height: element.offsetHeight
      }
    }
  })
}

const handleResize = () => {
  updateSectionsPosition()
}

onMounted(() => {
  updateSectionsPosition()
  if (contentRef.value) {
    contentRef.value.addEventListener('scroll', handleScroll)
  }
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  if (contentRef.value) {
    contentRef.value.removeEventListener('scroll', handleScroll)
  }
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped lang="less">
.about-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: #fff;
}

.banner-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  margin-bottom: 20px;
}

.banner-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-wrapper {
  display: flex;
  gap: 30px;
  padding: 0 300px;
  margin-bottom: 40px;
}

.left-sidebar {
  width: 250px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;
  align-self: flex-start;
}

.steps-wrapper {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.step-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  &:hover {
    background: #e6f7ff;
  }
  
  &.active {
    background: #1890ff;
    color: #fff;
  }
}

.step-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #d9d9d9;
  color: #595959;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  margin-right: 12px;
  transition: all 0.3s ease;
  
  .step-item.active & {
    background: #fff;
    color: #1890ff;
  }
}

.step-title {
  font-size: 16px;
  font-weight: 500;
}

.right-content {
  flex: 1;
  background-color: #fff;
  /* 移除内部滚动条，使用页面主滚动条 */
}

.content-section {
  margin-bottom: 80px;
  
  &:last-child {
    margin-bottom: 40px;
  }
}

.section-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #262626;
  padding-bottom: 12px;
  border-bottom: 2px solid #1890ff;
}

.section-content {
  font-size: 16px;
  line-height: 1.8;
  color: #333333;
}

/* 图片样式 */
.section-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 组织架构 */
.organization-group {
  margin-bottom: 24px;
  overflow: hidden;
}

.group-title {
  background-color: #1890ff;
  color: #fff;
  width: 100px;
  padding: 3px 7px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 8px;
  text-align: center;
}

.group-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.unit-list {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.unit-item {
  position: relative;
  padding-left: 20px;
  margin-bottom: 0;
  line-height: 1.6;
  flex: 1 1 calc(50% - 6px);
  min-width: 200px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  &::before {
    content: "•";
    position: absolute;
    left: 0;
    color: #1890ff;
    font-size: 18px;
    line-height: 1.4;
  }
}

.org-chart,
.org-level,
.org-node {
  display: none;
}

.qualifications-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 24px;
}

.qualification-item {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }
}

.qualification-icon {
  width: 80px;
  height: 80px;
  background: #1890ff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  margin: 0 auto 16px;
}

.qualification-image {
  width: 100%;
  height: 220px;
  border-radius: 8px;
  margin: 0 auto 16px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: block;
}

.qualification-name {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #262626;
}

.qualification-desc {
  font-size: 14px;
  color: #8c8c8c;
}

.contact-info {
  margin-bottom: 32px;
  flex: 1;
  padding-right: 30px;
}

.contact-item {
  display: flex;
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.contact-label {
  width: 100px;
  font-weight: 500;
  color: #262626;
  margin-right: 24px;
}

.contact-value {
  flex: 1;
  color: #595959;
}

.contact-value[alt="微信公众号"] {
  width: 125px;
  height: auto;
  object-fit: contain;
  flex: none;
}

.map-container {
  flex: 1;
  margin-left: 20px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  height: 500px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}


#company-map-container {
  width: 100%;
  height: 500px;
}


.contact-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.map-placeholder {
  font-size: 18px;
  color: #8c8c8c;
}

@media (max-width: 768px) {
  .about-container {
    flex-direction: column;
    padding: 10px;
    gap: 20px;
  }
  
  .banner-image {
    height: 200px;
  }
  
  .content-wrapper {
    flex-direction: column;
    padding: 0 10px;
    gap: 20px;
  }
  
  .left-sidebar {
    width: 100%;
    position: static;
  }
  
  .steps-wrapper {
    padding: 16px;
  }
  
  .right-content {
    height: auto;
    max-height: calc(100vh - 200px);
  }

  .group-content {
    flex-direction: column;
  }
  
  .unit-list {
    padding-right: 0;
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .org-level {
    flex-wrap: wrap;
    margin-bottom: 24px;
  }
  
  .org-node {
    margin: 8px;
    padding: 12px 24px;
    font-size: 16px;
  }
  
  .qualifications-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  /* 响应式下联系我们改为上下布局 */
  .contact-layout {
    flex-direction: column;
    gap: 20px;
  }
  
  .contact-info {
    margin-bottom: 0;
    padding-right: 0;
  }
}

.board-content {
  padding: 16px;
}

.board-item {
  margin-bottom: 8px;
}

.board-item:last-child {
  margin-bottom: 0;
}

.board-label {
  display: inline-block;
  width: 80px;
  font-weight: 500;
  margin-right: 8px;
}

.board-names {
  display: inline-block;
}
</style>